module.exports = __webpack_public_path__ + "img/get-inspired-dark.c1f98433.svg";